// SPDX-License-Identifier: AGPL-3.0-or-later
import {http} from '@app/features/platform/transport/RestTransport';

export async function enterReviewDemo(token?: string): Promise<boolean> {
	// The demo service is itself a sandbox: never re-enter from inside it. A signed-out sandbox
	// tab (sandbox ?signedout=1) plays the production sign-in, so it may enter.
	const sandbox = (window as Window & {__SANDBOX__?: {signedOut?: boolean}}).__SANDBOX__;
	if (sandbox && !sandbox.signedOut) return false;
	const response = await http.post<{demo: boolean}>('/konvo/demo/start', {
		body: {},
		...(token ? {headers: {Authorization: token}} : {}),
	});
	if (!response.body?.demo) return false;
	// The signed, HttpOnly cookie selects the isolated demo on the same origin.
	window.location.assign('/');
	return true;
}
